import { render, staticRenderFns } from "./ExpandingControlBox.vue?vue&type=template&id=06cf7704&scoped=true&"
import script from "./ExpandingControlBox.vue?vue&type=script&lang=js&"
export * from "./ExpandingControlBox.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingControlBox.vue?vue&type=style&index=0&id=06cf7704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf7704",
  null
  
)

export default component.exports